import { useContext } from "react";

import { PageTitleProviderContext } from "../../providers";
import menuIcon from "./../../../assets/img/menu.svg";
import { TopNavbarContents } from "./TopNavbarContents";

export function TopNavbar({ toggleSidebar }: { toggleSidebar: () => void }) {
  const { pageTitle } = useContext(PageTitleProviderContext);

  return (
    <>
      <div className="bg-gray-0 hidden min-h-14 flex-row items-center border-b border-gray-300 lg:inline-flex">
        <div className="text-primary-700 flex h-full min-w-fit items-center justify-center truncate border-r border-gray-300 px-8 font-semibold">
          {pageTitle.title}
        </div>
        <TopNavbarContents />
      </div>
      <div className="bg-primary-700 inline-flex min-h-14 flex-row items-center justify-between px-4 lg:hidden">
        <div className="text-gray-0 flex h-full min-w-fit items-center justify-center gap-x-2 truncate font-semibold">
          <img src={pageTitle.iconUrl} alt="Page Icon" className="size-5" />
          {pageTitle.title}
        </div>
        <div
          onClick={toggleSidebar}
          className="text-gray-0 flex cursor-pointer"
        >
          <img src={menuIcon} alt="Menu Icon" className="size-5" />
        </div>
      </div>
    </>
  );
}
